import React from "react"
import styled, { useTheme } from '~/ui/styled'
import { Flex, IconFont } from "~components/El"
import { CustomerAddButtonProps } from "./types"

const Content = styled(Flex)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
`

const CustomerAddButton: React.FC<CustomerAddButtonProps> = ({
  onClick,
}) => {
    const theme = useTheme()
    return (
        <Content onClick={onClick}>
            <IconFont name="jh" size={18} color={theme.colors.secondary} />
        </Content>
    )
}

export default CustomerAddButton
